import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductCreditCardConfig } from '../@types/context/product-credit-card-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactZmartaFiConfig } from './presets/contact-zmarta-fi.config';
import { creditCardFiConfig } from './presets/credit-card-fi.config';
import { globalFi } from './presets/global-fi.config';
import { myPageCcd2FiOptions } from './presets/mypage-ccd2-fi.config';
import { myPageOffersFiConfig } from './presets/mypage-offers-fi.config';
import { productConfigFi } from './presets/product-config.preset';
import { organisationZmartaFiConfig } from './presets/organisation-zmarta-fi.config';
import { serviceTrustpilotAxoConfig } from './presets/service-trustpilot-axo.config';
import { sitePathZmartaFiConfig } from './presets/site-path-zmarta-fi.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansFiConfig } from './presets/unsecured-loans-fi.config';

export const global: GlobalConfig = {
  brand: 'zmarta.fi',
  ...globalFi,
};

export const site: SiteConfig = {
  domain: 'zmarta.fi',
  name: 'Zmarta',
  theme: {
    name: 'zmarta',
    brand: 'zmarta',
  },
  ...sitePathZmartaFiConfig,
  ...organisationZmartaFiConfig,
  ...contactZmartaFiConfig,
  services: {
    trustpilot: {
      ...serviceTrustpilotAxoConfig,
      businessUnitId: '549803ff00006400057c4c1a',
      showInForms: true,
    },
    gtm: 'GTM-5S6FDL2R',
    ga: 'G-1QLRT7JZS7',
    launchDarkly: {
      enabled: true,
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansFiConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const productCreditCard: ProductCreditCardConfig = {
  ...creditCardFiConfig,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    isCreditCardRecommendedVisible: false,
    creditCard: { hasApplyForm: false },
    ...myPageOffersFiConfig,
    ...myPageCcd2FiOptions,
  },
  externalLinks: [
    // Receipts on Zmarta's own "My Account" page. Relative same-origin path: it
    // resolves against the origin that served the (reverse-proxied) Overview,
    // i.e. `/hakemukseni` → https://zmarta.fi/hakemukseni.
    // MV-2851 FI routing (resolved on the Zmarta side): `/omat-sivut`
    // reverse-proxies to OUR site-one Overview; `/hakemukseni` stays the old
    // Zmarta "My Account" — so this link is a genuine link-out, NOT circular.
    // No Elskling entry: not sold in FI.
    { key: 'zmarta', loginUrl: '/hakemukseni' },
  ],
};

export const product: ProductConfig = productConfigFi;
